module.exports = __webpack_public_path__ + "img/cases-brand-suning--lazyload-13.b2817512.jpg";